const CLOUDER_EMAIL_DOMAIN = '@cloudhumans.com';

const decodeTokenClaims = token => {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replaceAll('-', '+').replaceAll('_', '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const claims = JSON.parse(atob(padded));
    return claims && typeof claims === 'object' ? claims : null;
  } catch {
    return null;
  }
};

const isVerified = claim =>
  claim === true || String(claim).toLowerCase() === 'true';

const isClouderAdmin = claims =>
  claims['custom:hub_role'] === 'ADMIN' &&
  isVerified(claims.email_verified) &&
  typeof claims.email === 'string' &&
  claims.email.endsWith(CLOUDER_EMAIL_DOMAIN);

const hasClaudiaProjects = claims => {
  const projects = claims['custom:projects'];
  return typeof projects === 'string' && projects.length > 0;
};

export const tokenCanReachClaudiaConversations = token => {
  if (!token) return true;
  const claims = decodeTokenClaims(token);
  if (!claims) return true;
  return isClouderAdmin(claims) || hasClaudiaProjects(claims);
};
